import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container: `
      bg-green-100
      px-4
      py-2
    `,
    info: `
      after:mx-2
      after:inline-block
      after:h-1
      after:w-1
      after:rounded-full
      after:bg-neutral-900
      after:align-middle
      after:content-['']
    `,
  },
});
